import { Injectable } from '@angular/core';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs/internal/observable/of';
import { DebitCardDTO } from 'src/app/core/models/card';
import { CardService } from 'src/app/core/services/card.service';
import { AppState } from '../app.reducer';
import * as cardAction from './card.action';

@Injectable()
export class CardEffect {
  constructor(private cardService: CardService, private action$: Actions, private store: Store<AppState>) {}

  loadCard$ = createEffect(() =>
    this.action$.pipe(
      ofType(cardAction.CardActionTypes.CARD_LOAD),
      switchMap((action: any) => {
        return this.cardService.getCardsByIdMember(action.idMember).pipe(
          map((cardData: DebitCardDTO[]) => {
            return new cardAction.CardLoadSuccess(cardData);
          }),
          catchError(err => of(new cardAction.CardLoadFail(err)))
        );
      })
    )
  );
}
